import * as React from 'react';
import '../../../Typography/index.js';
import { Typography } from '../../../Typography/Typography.js';

var SelectionListLabel = /*#__PURE__*/React.memo(function (props) {
  var label = props.label,
    labelProps = props.labelProps;
  if (!label) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Typography, {
    tag: "span",
    variant: "body-s-strong",
    textColor: "base.default"
  }, /*#__PURE__*/React.createElement("div", labelProps, label));
});

export { SelectionListLabel };
//# sourceMappingURL=SelectionListLabel.js.map
